export const SESSION_ESTIMATOR_TEMP_ESTIMATE_TITLE = 'SessionEstimator_Project_';
